(() => {
  const element = document.getElementById('bm-routine-offer-config');
  if (!element) return;
  const config = JSON.parse(element.textContent);
  const variants = new Set(config.variants.map(String));
  const active = () => Date.now() >= Date.parse(config.start) && Date.now() < Date.parse(config.end);
  const eligibleItems = cart => (cart.items || []).filter(item => variants.has(String(item.variant_id || item.id)) && !item.selling_plan_allocation);
  const count = cart => eligibleItems(cart).reduce((sum, item) => sum + item.quantity, 0);
  let cartState = config.initialCart;
  let cartStateAt = Date.now();
  let inFlight;
  const displaySections = ['cart-drawer','cart-icon-bubble'];
  const remember = cart => {cartState = cart; cartStateAt = Date.now(); return cart;};
  const invalidate = () => {cartStateAt = 0;};
  async function request(path, payload) {
    const response = await fetch(config.root + path, {
      method: payload ? 'POST' : 'GET',
      headers: {'Content-Type':'application/json', Accept:'application/json'},
      ...(payload ? {body:JSON.stringify(payload)} : {}),
      cache:'no-store'
    });
    const data = await response.json();
    if (!response.ok || data.errors) throw new Error(data.description || config.error);
    if (Array.isArray(data.items) && Number.isFinite(data.item_count)) remember(data);
    return data;
  }
  async function getCart() { return remember(await request('cart.js')); }
  async function currentCart({fresh = false} = {}) {
    return !fresh && cartState && Array.isArray(cartState.discount_codes) && Date.now() - cartStateAt < 30000 ? cartState : getCart();
  }
  function cartFromSections(response, previous) {
    const html = response.sections?.['bm-routine-cart-state'];
    if (!html) return null;
    try {
      const text = new DOMParser().parseFromString(html,'text/html').querySelector('[data-bm-cart-state]')?.textContent;
      const cart = JSON.parse(text);
      if (!Array.isArray(cart.items) || !Number.isFinite(cart.item_count) || !Number.isFinite(cart.total_price)) return null;
      cart.discount_codes = Array.isArray(cart.discount_codes) ? cart.discount_codes : previous.discount_codes || [];
      cart.sections = response.sections;
      return remember(cart);
    } catch (_) {return null;}
  }
  async function sync({cart, sections = [], force = false, reuseSections = false} = {}) {
    cart = cart || await getCart();
    const existing = (cart.discount_codes || []).map(discount => discount.code).filter(Boolean);
    const external = existing.filter(code => !config.codes.includes(code.toUpperCase()));
    const eligible = active() && count(cart) >= 2;
    const codes = [...new Set([...external, ...(eligible ? config.codes : [])])];
    const hasReward = existing.some(code => config.codes.includes(code.toUpperCase()));
    const hasBothRewards = config.codes.every(code => existing.some(existingCode => existingCode.toUpperCase() === code));
    const sectionsReady = reuseSections && sections.every(section => cart.sections?.[section]);
    const shouldUpdate = force || (sections.length && !sectionsReady) || (eligible && !hasBothRewards) || (!active() && hasReward);
    if (shouldUpdate) cart = await request('cart/update.js', {discount:codes.join(','), ...(sections.length ? {sections,sections_url:window.location.pathname} : {})});
    remember(cart);
    return cart;
  }
  function render(cart, open = false) {
    const drawer = document.querySelector('cart-drawer');
    const sections = cart.sections || {};
    if (sections['cart-drawer'] && drawer) {
      const incoming = new DOMParser().parseFromString(sections['cart-drawer'],'text/html').querySelector('#CartDrawer');
      if (incoming) {
        const wasOpen = drawer.hasAttribute('open');
        const currentPanel = drawer.querySelector('.cart-drawer__inner');
        const incomingPanel = incoming.querySelector('.cart-drawer__inner');
        // Keep the moving panel mounted while cart data refreshes.
        if (currentPanel && incomingPanel) currentPanel.replaceChildren(...incomingPanel.childNodes);
        else drawer.innerHTML = incoming.innerHTML;
        drawer.classList.toggle('is-empty',!cart.item_count);
        if (wasOpen || open) drawer.open(document.getElementById('cart-icon-bubble'));
      }
    }
    if (sections['cart-icon-bubble']) {
      const incoming = new DOMParser().parseFromString(sections['cart-icon-bubble'],'text/html').querySelector('.shopify-section');
      const current = document.getElementById('cart-icon-bubble');
      if (incoming && current) current.innerHTML = incoming.innerHTML;
    }
    remember(cart);
    document.dispatchEvent(new CustomEvent('bm:routine-cart',{detail:{cart}}));
    if (open && !drawer) window.location.assign(config.root + 'cart');
  }
  async function refreshDisplay() {
    if (inFlight) return inFlight;
    inFlight = (async () => {
      let cart = await currentCart();
      if (!displaySections.every(section => cart.sections?.[section])) cart = await sync({cart,sections:displaySections,force:true});
      render(cart);
      return cart;
    })().finally(() => {inFlight = null;});
    return inFlight;
  }
  window.BMRoutineOffer = {config,active,eligibleItems,count,request,getCart,currentCart,cartFromSections,sync,render,refreshDisplay,get state(){return cartState;}};
  window.addEventListener('focus',invalidate);
  document.addEventListener('visibilitychange',() => {if(document.visibilityState === 'visible')invalidate();});
  document.addEventListener('bm:routine-cart',event => {if(event.detail?.cart)remember(event.detail.cart);});
  document.addEventListener('DOMContentLoaded', () => {
    if (document.querySelector('bm-routine-builder')) return;
    if (active() && count(cartState) >= 2) refreshDisplay().catch(() => {});
  },{once:true});
  document.addEventListener('click', event => {
    if (!event.target.closest('#cart-icon-bubble')) return;
    refreshDisplay().catch(() => {
      const message = document.querySelector('[data-bm-offer-error]');
      if (message) {message.textContent = config.error; message.hidden = false;}
    });
  });
})();
